import { render } from "./SpecimenRequirementList.vue?vue&type=template&id=6104447d"
import script from "./SpecimenRequirementList.vue?vue&type=script&lang=js"
export * from "./SpecimenRequirementList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__